import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { evidenceOfFormationDocumentTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const EvidenceOfFormationFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={evidenceOfFormationDocumentTypesArray}
        placeholder="Select an evidence of formation document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default EvidenceOfFormationFormValues;
